import { useRequiredContext } from "@redotech/react-util/context";
import ReceiptCheckIcon from "@redotech/redo-icons/receipt-check.svg";
import ReceiptCheckFilledIcon from "@redotech/redo-icons/receipt-check_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const CheckoutItems = memo(function CheckoutItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getConversionSubRoute("checkouts") }}
      FilledIcon={ReceiptCheckFilledIcon}
      friendlyName="Checkouts"
      id="checkouts"
      UnfilledIcon={ReceiptCheckIcon}
    />
  );
});
